import { getDetectEventDevice } from "./../api/detect";
import { useQuery } from "@tanstack/react-query";
import { GetDetectEventDeviceParams } from "./../types/types";
import userStorage from "../utils/userStorage";

const useGetDetectEventDevice = ({
  endDate,
  event_code,
  groupId,
  limit,
  mobility_code,
  mobility_seq,
  ownerID,
  page,
  startDate,
}: GetDetectEventDeviceParams) => {
  const user = userStorage.get();
  const { data, isSuccess, isLoading, isError } = useQuery({
    queryKey: [
      "DetectEventDevice",
      `area-${user?.area}`,
      `endDate-${endDate}`,
      `event_code-${event_code}`,
      `groupId-${groupId}`,
      `limit-${limit}`,
      `mobility_code-${mobility_code}`,
      `mobility_seq-${mobility_seq}`,
      `ownerID-${ownerID}`,
      `page-${page}`,
      `startDate-${startDate}`,
    ],
    queryFn: () =>
      getDetectEventDevice({
        area: user?.area as string,
        endDate,
        event_code,
        groupId,
        limit,
        mobility_code,
        mobility_seq,
        ownerID,
        page,
        startDate,
      }),

    retry: false,
  });
  return { data, isSuccess, isLoading, isError };
};

export default useGetDetectEventDevice;
